var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMasaailActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 262.108,
    height: 195.231,
    viewBox: "0 0 262.108 195.231",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7970",
    "data-name": "Group 7970",
    transform: "translate(-45.876 -292.013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39376",
    "data-name": "Path 39376",
    d: "M46.356,293.513h170.7A26.245,26.245,0,0,1,243.3,319.759h0A26.245,26.245,0,0,1,217.052,346H46.356",
    transform: "translate(2.317)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39377",
    "data-name": "Path 39377",
    d: "M208.513,293.513H48.124a42.742,42.742,0,0,1,0,52.491H208.513a26.245,26.245,0,0,0,26.246-26.245h0A26.245,26.245,0,0,0,208.513,293.513Z",
    transform: "translate(10.856)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39378",
    "data-name": "Path 39378",
    d: "M84.355,313.137",
    transform: "translate(185.844 94.78)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39379",
    "data-name": "Path 39379",
    d: "M254.846,304.133H75.3a26.248,26.248,0,0,0-26.246,26.246h0A26.248,26.248,0,0,0,75.3,356.624",
    transform: "translate(15.353 51.292)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39380",
    "data-name": "Path 39380",
    d: "M235.445,330.3a42.722,42.722,0,0,0,9.007,26.386H174.3V329.051H146.034V356.69H75.249a26.281,26.281,0,0,1,0-52.561h169.2A42.594,42.594,0,0,0,235.445,330.3Z",
    transform: "translate(15.44 51.273)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39381",
    "data-name": "Path 39381",
    d: "M268.825,314.765a34.168,34.168,0,0,1,34.168,34.168h0A34.168,34.168,0,0,1,268.825,383.1H46.6",
    transform: "translate(3.491 102.642)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39382",
    "data-name": "Path 39382",
    d: "M46.6,314.765",
    transform: "translate(3.491 102.643)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39383",
    "data-name": "Path 39383",
    d: "M291.81,348.9a34.143,34.143,0,0,1-34.139,34.133H48.894A55.179,55.179,0,0,0,60.618,348.9a55.63,55.63,0,0,0-11.724-34.133h98V337.8l14.026-9,14.236,9V314.762H257.67A34.143,34.143,0,0,1,291.81,348.9Z",
    transform: "translate(14.575 102.628)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39384",
    "data-name": "Path 39384",
    d: "M93.972,314.762V337.8l-14.238-9-14.029,9V314.762",
    transform: "translate(95.767 102.629)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1666",
    "data-name": "Line 1666",
    x2: 89.887,
    transform: "translate(75.788 447.455)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1667",
    "data-name": "Line 1667",
    x2: 89.887,
    transform: "translate(69.04 319.758)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1668",
    "data-name": "Line 1668",
    x2: 118.941,
    transform: "translate(75.788 464.446)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1669",
    "data-name": "Line 1669",
    x1: 115.594,
    transform: "translate(45.876 417.391)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1670",
    "data-name": "Line 1670",
    x1: 82.507,
    transform: "translate(189.741 417.391)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39385",
    "data-name": "Path 39385",
    d: "M93.972,313.146V345.6l-14.238-9-14.029,9V313.146",
    transform: "translate(95.767 94.82)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasaailActive);
export default __webpack_public_path__ + "static/media/Masaail_active.60a06ff9dff11fe26b5fb436ab8c1dd9.svg";
export { ForwardRef as ReactComponent };